import React, { Component } from "react";
import Historic from "../../../components/Historic/Historic";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : VacationForm
Description : Compoente que alberga el formulario de Vacation definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class HistoricForm extends Component {
    render() {
        return (
            <Historic />
        )
    }
}

export default HistoricForm;